var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"invoice-view"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('invoice-view',{attrs:{"invoice-uuid":_vm.invoiceUuid}})],1),_c('div',{staticClass:"col-3"},[_c('invoice-view-sidebar')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }